import './header.scss';
import React, { useEffect, useState } from 'react';
import ReorderIcon                    from '@material-ui/icons/Reorder';
import { useDispatch, useSelector }   from 'react-redux';
import { useInput }                   from '../custom-hooks/input-hook';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import { Button }                     from '@material-ui/core';
import { getProfile }                 from '../../shared/services/user/user-service';
import profileActions                 from '../../store/actions/profile.action';
import AuthenticationDialogHandler    from '../authentication-dialog-handler/authentication-dialog-handler';
import ImageGenerator from '../image-generator/image-generator';
import defaultLogo from '../../../src/assets/images/bebin-logo.svg';
import searchIcon from '../../assets/images/Search.svg'
import arrowDown from '../../assets/images/arrow-Down.svg'
import SearchDialog from '../../pages/search/search-dialog';
import { getListCategory, getListGenre } from '../../shared/services/category/category-service';
import { useConfigApp } from '../../shared/services/general/app-context';

function Header () {
	const headerMenu                                  = [
		{
			title: 'خانه',
			url  : '/'
		},
		{
			title: 'فیلم ها',
			url  : '/movies'
			// url  : '/'
		},
		{
			title: 'سریال ها',
			url  : '/series'
		},
		//		{
		//			title: 'اکران آنلاین',
		//			url  : '/'
		//		},

	];
	const { profile, isLoad }                                 = useSelector(state => state.profileData);
	const dispatch                                    = useDispatch();
	const { value: search, bind: bindSearch }         = useInput('');
	const [openProfileDialog, setOpenProfileDialog]   = useState(false);
	const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
	const [openSearchDialog, setOpenSearchDialog] = useState(false);
	const [logo, setLogo] = useState([]);
	const [categoryList, setCategoryList] = useState([]);
	const [genreList, setGenreList] = useState([]);
	const configApp = useConfigApp();
	const location = useLocation();
	const currentPath = location.pathname;

	useEffect(() => {
		getCategory()
		getGenre()
	}, []);
	useEffect(() => {
		if (configApp) {
			const imgLogo = configApp?.logo ? require(`../../../src/assets/images/${configApp?.logo}`).default : defaultLogo;
			setLogo(imgLogo)
		}
	}, [configApp]);

	const getCategory = () => {
		getListCategory().then(
			(res) => {
				if (res.data.code === 200) {
					setCategoryList(res.data.data);
					const categoryList = res.data.data.map(item => ({
						id: item.id,
						value: item.value,
					}));
					localStorage.setItem('catList', JSON.stringify(categoryList));
				}
			},
		);
	};

	const getGenre = () => {
		getListGenre().then(
			(res) => {
				if (res.data.code === 200) {
					setGenreList(res.data.data);
					const genreList = res.data.data.map(item => ({
						id: item.id,
						value: item.value,
					}));
					localStorage.setItem('genreList', JSON.stringify(genreList));
				}
			},
		);
	};

	useEffect(() => {
		if (JSON.stringify(profile) === '{}' || !profile) {
			getProfile().then(
				(result) => {
					if (result.status === 200 && result.data.code === 200) {
						let data = result.data.data;
						dispatch(profileActions(data));
					}
				}
			);
		}
	}, [profile, dispatch]);

	const searchBox = () => {
		// const handleSubmit = (e) => {
		// 	e.preventDefault();
		// 	history.push('/search/' + search);
		// };
		//
		// return (
		// 	<form autoComplete="off"
		// 		  className="header-search-box"
		// 		  dir="rtl"
		// 		  onSubmit={handleSubmit}>
		// 		<input placeholder="جستجو"
		// 			   {...bindSearch}
		// 			   type="text"
		// 		/>
		// 	</form>
		// );
		return (
			<>
				<div className='box-handler-search' onClick={() => setOpenSearchDialog(!openProfileDialog)}>
					<ImageGenerator src={searchIcon} name={'search'}/>
				</div>
			</>
		);
	};

	function checkForSerial(str) {
		return str.includes("سریال") || (!str.includes("فیلم") && currentPath.includes("series"));
	}


	const renderCategory = () => {
		 return categoryList?.map((data) => {
			 const result = checkForSerial(data?.value);
			 return <>
				 <li>
					 <Link className='item' key={data.id}
						   to={`/t/category/${data.id}/${result ? 'series' : 'movies'}`}>
						 {data?.value}
					 </Link>
				 </li>
			 </>
		})
	}

	const generateLink = (currentPath, genreId) => {
		const isSeriesPage = currentPath.includes('/series');
		return isSeriesPage
			? `/t/genre/${genreId}/series`
			: `/t/genre/${genreId}/movies`;
	};

	const renderGenre = () => {
		 return genreList?.map((data) => {
			 return <>
				 <li>
					 <Link className='item' key={data.id}
						   to={generateLink(currentPath, data.id)}>
						 {data?.value}
					 </Link>
				 </li>
			 </>
		})
	}

	const profileBox = () => {
		const goToRegister = () => <Button variant={'text'}
										   onClick={() => setOpenRegisterDialog(true)}>
			<span>ورود و ثبت‌نام</span>
		</Button>;

		return (
			<div className="user-name">
				{JSON.stringify(profile) === '{}' || !profile ? goToRegister() : <>
					<Button variant={'text'}
							onClick={() => setOpenProfileDialog(true)}><>
						<div className="more-icon">
							<ReorderIcon/>
						</div>
						{profile?.name}
					</>
					</Button>
				</>}
			</div>
		);
	};

	return (
		<header id="header">
			<div className="right-side-section">
				{(configApp && logo) && (<Link to={'/'}
								  className={configApp?.logo ? 'logo custom ' + configApp?.titleEn : 'logo'}><img
					src={logo} alt="" /></Link>)}
				<ul>
					{headerMenu.map((value, index) =>
						<li key={index}>
							<NavLink exact activeClassName="is-active"
									 to={value.url}><span>{value.title}</span></NavLink>
						</li>,
					)}
					{isLoad === undefined && profile === undefined || (profile && profile?.parentalControlCode === 5) || (profile && !profile?.parentalControlCode) ? (
						<>
							<li className="mega-menu">
								<Link className="item" to={'/category'}>
									<span>
										دسته بندی ها
										<ImageGenerator src={arrowDown} name={''}/>
									</span>
								</Link>

								<ul>
									{renderCategory()}
								</ul>
							</li>
							<li className="mega-menu">
								<Link className="item" to={'/genre'}>
									<span>
										ژانر ها
										<ImageGenerator src={arrowDown} name={''}/>
									</span>
								</Link>
								<ul>
									{renderGenre()}
								</ul>
							</li>
						</>
					) : null}
				</ul>
			</div>
			<div className="left-side-section">
				{profileBox()}
				{searchBox()}
			</div>
			<AuthenticationDialogHandler openProfileDialog={openProfileDialog}
										 setOpenProfileDialog={setOpenProfileDialog}
										 openRegisterDialog={openRegisterDialog}
										 setOpenRegisterDialog={setOpenRegisterDialog}/>
			<SearchDialog open={openSearchDialog}
						   onClose={() => setOpenSearchDialog(false)}></SearchDialog>
		</header>
	);
}

export default Header;
